import { Pagination, EffectFade } from 'swiper/modules'

import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import 'swiper/css'

// eslint-disable-next-line import/order
import Link from 'next/link'
// eslint-disable-next-line import/order
import { Image } from "@graphcommerce/image";
// eslint-disable-next-line import/order
import { useEffect, useState } from 'react';
import IconBxArrowBack from '../../../icons/backward';
import IconArrowForward from '../../../icons/forward';

export type AdsSliderProps = {
  images: string[];
  className?: string;
}

const ChangeSlide = ({ position }: { position: number }) => {
  const swiper = useSwiper()

  useEffect(() => {
    if (swiper) {
      swiper.slideTo(position)
    }
  }, [swiper, position])
  return null
}



// eslint-disable-next-line import/no-default-export
export default function AdsSlider(props: AdsSliderProps) {
  const [selected, setSelected] = useState<number>(0)

  const { images, className } = props

  useEffect(
    () => {
      const timer = setInterval(() => {
        if (selected + 1 === images?.length)
          setSelected(0)
        else {
          setSelected(selected + 1)
        }
      }, 4000);

      return function cleanup() {

        clearInterval(timer);
      };
    },
    [selected]
  );

  const handelNext = () => {
    if (selected + 1 === images?.length)
      setSelected(0);
    else setSelected(selected + 1);

  }

  const handelPrev = () => {
    if (selected === 0 && images?.length)
      setSelected(Number(images?.length) - 1)
    else setSelected(selected - 1)
  }

  return (
    <div className={`${className} md:flex-1 w-full mx-auto  overflow-hidden`}>
      <Swiper
        modules={[EffectFade, Pagination]}
        pagination
        loop
        slidesPerView={1}
        spaceBetween={30}
        effect="fade"
        className='items-center'
        onSlideChange={(e) => {
          if (e?.activeIndex !== selected)
            setSelected(e?.activeIndex)
        }}
      >
        <ChangeSlide position={selected} />
        <button className='bg-[#00000045] absolute bottom-5 left-20 z-[1] p-1 rounded-md' onClick={handelNext} ><IconArrowForward width={20} height={15} className='text-white' /></button>
        <button className='h-auto bg-[#00000045] absolute bottom-5 left-10 z-[1]  p-1 rounded-md' onClick={handelPrev} ><IconBxArrowBack width={20} height={15} className='text-white' /></button>
        {images && images.length && images.map((item) => (
          <SwiperSlide key={item} className='h-full'>
            <Link href="#" className='overflow-hidden inline-block w-full h-full relative'>
              <Image width={100} height={100} className='!object-cover w-auto min-h-[200px]' src={item} />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}